(() => {
  const KEY = "msh_intro_seen_session";
  const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) return;
  if (sessionStorage.getItem(KEY) === "1") return;

document.documentElement.classList.remove('msh-intro-preload');


  const intro = document.getElementById("mshIntro");
  const introLogo = document.getElementById("mshIntroLogo");
  if (!intro || !introLogo) return;

  const headerLogoEl =
    document.querySelector(".header__heading-link img") ||
    document.querySelector(".header__heading-link svg");
  if (!headerLogoEl) return;

  // Clone the real header logo so the intro always matches what’s set in Dawn
  const clone = headerLogoEl.cloneNode(true);
  clone.removeAttribute("width");
  clone.removeAttribute("height");
  introLogo.appendChild(clone);

  const HOLD = 700;         // logo holds briefly on white
  const MOVE_DUR = 2200;    // movement duration
  const EASE = "cubic-bezier(.16, 1, .3, 1)";

  intro.classList.add("is-active");
  document.documentElement.classList.add("msh-intro-lock");
  document.body.classList.add("msh-intro-lock", "msh-intro-hide-header-logo");

  // Floating wrapper
  const floating = document.createElement("div");
  floating.style.position = "fixed";
  floating.style.left = "50%";
  floating.style.top = "42%";
  floating.style.transform = "translate(-50%, -50%) scale(1)";
  floating.style.transformOrigin = "center";
  floating.style.zIndex = "10000";
  floating.style.pointerEvents = "none";

  floating.appendChild(introLogo.firstElementChild);
  intro.appendChild(floating);

  function animateToHeader() {
    const from = floating.getBoundingClientRect();
    const to = headerLogoEl.getBoundingClientRect();

    const dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    const dy = (to.top + to.height / 2) - (from.top + from.height / 2);
    const scaleEnd = to.width / from.width;

    const anim = floating.animate(
      [
        { transform: "translate(-50%, -50%) scale(1)" },
        { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(${scaleEnd})` }
      ],
      { duration: MOVE_DUR, easing: EASE, fill: "forwards" }
    );

    anim.onfinish = () => {
      document.body.classList.remove("msh-intro-hide-header-logo");

      intro.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 650,
        easing: "cubic-bezier(.2,.8,.2,1)",
        fill: "forwards"
      }).onfinish = () => {
        intro.remove();
        document.documentElement.classList.remove("msh-intro-lock");
        document.body.classList.remove("msh-intro-lock");
        sessionStorage.setItem(KEY, "1");
      };
    };
  }

  setTimeout(() => requestAnimationFrame(animateToHeader), HOLD);
})();
